import "../PayPortal.css";

export default function PrivacyPage() {
  return (
    <main className="pay-page">
      <section className="pay-review">
        <div className="pay-pills">
          <span>Datenschutz</span>
          <span>Pay Portal</span>
        </div>

        <h1>Datenschutzhinweise für das DebitorManager Pay Portal</h1>

        <p className="pay-text">
          Stand: Juni 2026
        </p>

        <div className="pay-review-card">
          <h2>1. Verantwortlicher</h2>
          <p>
            DI Direkt Inkasso GmbH<br />
            Albert-Einstein-Straße 10<br />
            87437 Kempten<br />
            E-Mail: datenschutz@direkt-inkasso.de
          </p>

          <h2>2. Zweck der Datenverarbeitung</h2>
          <p>
            Das DebitorManager Pay Portal ermöglicht die sichere Begleichung
            offener Forderungen. Personenbezogene Daten werden verarbeitet, um
            Zahlungen einer Forderung zuzuordnen, Zahlungseingänge zu
            dokumentieren und gesetzliche Nachweis- und Aufbewahrungspflichten
            zu erfüllen.
          </p>

          <h2>3. Verarbeitete Daten</h2>
          <p>
            Verarbeitet werden insbesondere Aktenzeichen, Name des Schuldners,
            Gläubiger, Forderungsbetrag, Zahlungsbetrag, Zahlungsstatus,
            E-Mail-Adresse, Mobilnummer sowie technische Daten wie Zeitstempel,
            Browserinformationen und Transaktionsreferenzen.
          </p>

          <h2>4. Zahlungsdienstleister Stripe</h2>
          <p>
            Für die Zahlungsabwicklung nutzen wir Stripe. Die Eingabe von
            Kreditkarten- oder Zahlungsdaten erfolgt unmittelbar über Stripe.
            Die DI Direkt Inkasso GmbH speichert keine vollständigen
            Kreditkarten- oder Bankkartendaten.
          </p>

          <h2>5. Rechtsgrundlagen</h2>
          <p>
            Die Verarbeitung erfolgt insbesondere auf Grundlage von Art. 6 Abs.
            1 lit. b DSGVO, Art. 6 Abs. 1 lit. c DSGVO sowie Art. 6 Abs. 1 lit.
            f DSGVO.
          </p>

          <h2>6. Hosting und Sicherheit</h2>
          <p>
            Das Portal wird in einer cloudbasierten Infrastruktur betrieben.
            Datenübertragungen erfolgen verschlüsselt mittels TLS. Es werden
            angemessene technische und organisatorische Maßnahmen zum Schutz der
            Daten eingesetzt.
          </p>

          <h2>7. Speicherdauer</h2>
          <p>
            Personenbezogene Daten werden nur so lange gespeichert, wie dies für
            die Zahlungsabwicklung, die Bearbeitung des Inkassovorgangs oder
            gesetzliche Aufbewahrungspflichten erforderlich ist.
          </p>

          <h2>8. Betroffenenrechte</h2>
          <p>
            Betroffene Personen haben insbesondere Rechte auf Auskunft,
            Berichtigung, Löschung, Einschränkung der Verarbeitung,
            Datenübertragbarkeit, Widerspruch sowie Beschwerde bei einer
            Datenschutzaufsichtsbehörde.
          </p>

          <h2>9. Kontakt</h2>
          <p>
            Für Datenschutzanfragen wenden Sie sich bitte an:<br />
            datenschutz@direkt-inkasso.de
          </p>
        </div>

        <button
          type="button"
          className="pay-button secondary"
          onClick={() => {
            window.location.href = "/";
          }}
        >
          Zurück zum Pay Portal
        </button>
      </section>
    </main>
  );
}